/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("SalesOrderRequestsController", [
            "$scope", "$http", "$sessionStorage", "$uibModal", "$user", "$oidc", "$translate", "$notifications", "$decisionBox", "$location",
            function ($scope, $http, $sessionStorage, $uibModal, user, oidc, translate, notifications, decisionBox, $location) {

                $scope.$storage = $sessionStorage;
                $scope.user = user;
                $scope.requestTypes = [];
                $scope.requestType = null;

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                        $scope.browse();
                    }
                });

                $scope.list = [];
                $scope.browse = function () {
                    return $http.get("/api/requests/search", {
                        params: {
                            retailerId: $scope.$storage.retailer.Id
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    }).then(function (response) {
                        $scope.list = response.data;
                        if ($scope.requestTypes.length == 0) {
                            $scope.requestTypes = [...new Map(response.data.map(item => [item["RequestTypeId"], { "Id": item.RequestTypeId, "Code": item.RequestTypeCode, "Name": item.RequestTypeName }])).values()]   
                        }
                    });
                };

                $scope.$watch("language", function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.browse();
                    }
                });

                // Filter
                $scope.filterByType = function (item) {
                    if ($scope.$storage.salesOrderRequest.requestTypeId === null) {
                        return true;
                    }

                    if (item.RequestTypeId === $scope.$storage.salesOrderRequest.requestTypeId) {
                        return true;
                    }

                    return false;
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.salesOrderRequest.orderName === orderName) {
                        $scope.$storage.salesOrderRequest.orderDesc = !$scope.$storage.salesOrderRequest.orderDesc;
                    } else {
                        $scope.$storage.salesOrderRequest.orderName = orderName;
                        $scope.$storage.salesOrderRequest.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.salesOrderRequest.orderName === orderName) {
                        if ($scope.$storage.salesOrderRequest.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                $scope.onRequestTypeChanged = function () {
                    $scope.$storage.salesOrderRequest.requestTypeId = $scope.requestType !== null ? $scope.requestType.Id : null;
                };

                $scope.cancelRequest = function (item) {
                    return decisionBox
                        .showConfirm(
                            "SalesOrderLineCancelTitle",
                            "SalesOrderLineCancelMessage",
                            "Yes",
                            "No"
                        )
                        .result
                        .then(function () {
                            return _cancelRequest($scope.$storage.retailer.Id, item.Id)
                                .then(function () {
                                    return $scope.browse();
                                });
                        }, function (data) { });
                };

                function _cancelRequest(retailerId, salesOrderRequestId) {
                    return $http
                        .delete("/api/requests/" + salesOrderRequestId + "/cancel", {
                            params: {
                                retailerId: retailerId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            translate("SalesOrderLineCanceledSuscessfully")
                                .then(function (translation) {
                                    notifications.addSuccess(translation);
                                }, function () {
                                    notifications.addSuccess("Sales order canceled successfully.");
                                });
                        }, function (error) {
                            translate("SalesOrderLineCancelFailed")
                                .then(function (translation) {
                                    notifications.addError(translation, error);
                                }, function () {
                                    notifications.addSuccess("Sales order cancel failed.", error);
                                });
                        });
                }

                $scope.confirmPriceRequest = function (item) {
                    return decisionBox
                        .showConfirm(
                            "ConfirmSalesOrderRequestPriceTitle",
                            "ConfirmSalesOrderRequestPriceMessage",
                            "Yes",
                            "No"
                        )
                        .result
                        .then(function () {
                            return _confirmPriceRequest($scope.$storage.retailer.Id, item.Id)
                                .then(function () {
                                    return $scope.browse();
                                });
                        }, function (data) { });
                };

                function _confirmPriceRequest(retailerId, salesOrderRequestId) {
                    return $http
                        .put("/api/requests/" + salesOrderRequestId + "/process", {}, {
                            params: {
                                retailerId: retailerId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            translate("ConfirmSalesOrderRequestPriceSuscessfully")
                                .then(function (translation) {
                                    notifications.addSuccess(translation);
                                }, function () {
                                    notifications.addSuccess("Sales order request process successfully.");
                                });
                        }, function (error) {
                            translate("ConfirmSalesOrderRequestPriceFailed")
                                .then(function (translation) {
                                    notifications.addError(translation, error);
                                }, function () {
                                    notifications.addSuccess("Sales order request process failed.", error);
                                });
                        });
                }

                $scope.changeModel = function (item) {
                    if (item.StatusCode === "CAN") {
                        $location.path("/sales-order-requests-model-change").search({ id: item.Id });
                    } else {
                        _cancelSalesOrderLine($scope.$storage.retailer.Id, item.OrderLineId)
                            .then(function () {
                                $location.path("/sales-order-requests-model-change").search({ id: item.Id });
                            });
                    }
                };

                function _cancelSalesOrderLine(retailerId, salesOrderLineId) {
                    return $http
                        .delete("/api/retailer/" + retailerId + "/sales-order/line/" + salesOrderLineId, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            
                        }, function (error) {
                            translate("SalesOrderLineCancelFailed")
                                .then(function (translation) {
                                    notifications.addError(translation, error);
                                }, function () {
                                    notifications.addSuccess("Sales order cancel failed.", error);
                                });
                        });
                }

                $scope.confirmModelRequest = function (item) {
                    return decisionBox
                        .showConfirm(
                            "ConfirmSalesOrderRequestModelTitle",
                            "ConfirmSalesOrderRequestModelMessage",
                            "Yes",
                            "No"
                        )
                        .result
                        .then(function () {
                            return _confirmModelRequest($scope.$storage.retailer.Id, item.Id)
                                .then(function () {
                                    return $scope.browse();
                                });
                        }, function (data) { });
                };

                function _confirmModelRequest(retailerId, salesOrderRequestId) {
                    return $http
                        .put("/api/requests/" + salesOrderRequestId + "/process", {}, {
                            params: {
                                retailerId: retailerId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            translate("ConfirmSalesOrderRequestModelSuscessfully")
                                .then(function (translation) {
                                    notifications.addSuccess(translation);
                                }, function () {
                                    notifications.addSuccess("Sales order request process successfully.");
                                });
                        }, function (error) {
                            translate("ConfirmSalesOrderRequestModelFailed")
                                .then(function (translation) {
                                    notifications.addError(translation, error);
                                }, function () {
                                    notifications.addSuccess("Sales order request process failed.", error);
                                });
                        });
                }

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.browse();
                }
            }
        ]);
})();